<template>
  <div>
    <template v-if="loading">
      <v-skeleton-loader type="image" width="100%;"></v-skeleton-loader>
    </template>
    <template v-else>
      <v-img :src="base64Image"></v-img>
    </template>
  </div>
</template>
<script>
export default {
  props: {
    categoryId: {
      type: Number,
    },
  },
  data: () => ({
    image: null,
    loading: false,
    base64Image: null,
  }),
  methods: {
    getImage() {
      this.loading = true;
      this.base64Image = null;
      axios.get(`/getCategoryImage?categoryId=${this.categoryId}`).then(({ data }) => {
        if (data.success) {
          this.base64Image = data.image;
        }
        this.loading = false;
      });
    },
  },
  created() {
    this.getImage();
  },
  watch: {
    categoryId() {
      this.getImage();
    },
  },
};
</script>
